import { useKeycloak } from "@react-keycloak/web";
import Cookies from "js-cookie";
import { Fragment, useEffect } from "react";
import Loader from "./shared/loader/loader";
import { setLanguage } from "react-switch-lang";

const App: React.FC = ({ children }) => {

  const { initialized } = useKeycloak();
  useEffect(() => {
    setLanguage(Cookies.get("language") || "fr");
  }, []);

  if (!initialized) {
    return <Loader />;
  }

  return (
    <Fragment>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper">
          <div>{children}</div>
        </div>
      </div>
    </Fragment>
  );
};

export default App;
